/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifactpackdescription2Inputs */

const en_artifactpackdescription2 = /** @type {(inputs: Artifactpackdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hand a Portuguese lawyer or tribunal a complete, formatted case in under a minute. Built on the CPC art. 552 layout they expect — so they don't reformat anything.`)
};

const pt_artifactpackdescription2 = /** @type {(inputs: Artifactpackdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entregue a um advogado ou tribunal português um caso completo e formatado em menos de um minuto. Construído sobre o formato CPC art. 552.º que eles esperam — para ninguém ter de reformatar nada.`)
};

/**
* | output |
* | --- |
* | "Hand a Portuguese lawyer or tribunal a complete, formatted case in under a minute. Built on the CPC art. 552 layout they expect — so they don't reformat anyt..." |
*
* @param {Artifactpackdescription2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const artifactpackdescription2 = /** @type {((inputs?: Artifactpackdescription2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifactpackdescription2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_artifactpackdescription2(inputs)
	return pt_artifactpackdescription2(inputs)
});
export { artifactpackdescription2 as "artifactPackDescription" }